import {ParentView} from '../../ladmin/components/LParentView'
import Main from '../../views/main'
export default [
  /* -------------- 路由测试 ----------- */
  {
    path: '/test-router-parent',
    name: 'TestRouterParent',
    component: Main,
    meta: {
      label: '违章处理',
      disabled: true
    },
    children: [
      {
        path: 'test-router-1',
        name: 'TestRouter1',
        component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/testRouter1'),
        meta: {
          label: '固定页面',
        }
      },
      {
        path: 'test-router-2',
        name: 'TestDetailsParent',
        redirect: {name: 'TestRouter2'},
        component: ParentView,
        meta: {
          label: '违章事件处理',
          // subText: 'query.id'
        },
        children: [
          {
            path: 'admin',
            name: 'TestDetailsSecondParent',
            component: ParentView,
            meta: {
              label: '管理员处理',
              disabled: true
            },
            children: [
              {
                path: 'details',
                name: 'TestDetails',
                component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/detailsPage'),
                meta: {
                  label: '违章事件详情',
                  subText: 'query.id',
                  cacheKey: 'query.id',
                  beforeCloseName: 'defaultBeforeClose'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'test-router-2',
        name: 'TestRouter2',
        component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/testRouter2'),
        meta: {
          label: '违章事件处理'
        },
        children: [
          {
            path: 'details-:id',
            name: 'TestDetailsParams',
            component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/paramsPage'),
            meta: {
              label: '违章事件上报',
              subText: 'params.id'
            }
          },
        ]
      },
      {
        path: 'test-router-3',
        name: 'TestRouter3',
        component: () => import(/* webpackChunkName: "test" */ '@/views/testPage/testRouter3')
      },
    ],
  },
]
